module.exports = __webpack_public_path__ + "assets/img/2529592125decaca435f16d94dfd0eb2.svg";